export default function authHeader() {
    const token = JSON.parse(localStorage.getItem('token'));

    if (token) {
        return { "authorization": `Bearer ${token}` };
    } else {
        return {};
    }
}